import React from 'react';
import TextField from '@material-ui/core/TextField';
import IntlMessages from 'util/IntlMessages';

function KontaktRoll(props) {
    const [Value,setValue] = React.useState(props.Role)
    const [id,setid] = React.useState('')
    const [disAbled,setdisAbled] = React.useState(true)
    const onchangeHandle=(e)=>{
        setValue(e.target.value)
    }
    const onBlurHandle=()=>{
        props.onchangeHanelKontakt("Role",Value)
    }
    React.useEffect(()=>{
        if(id !== parseInt(props.id)){
            setid(props.id)
            setValue(props.Role)
            if(props.id === ""){
                setdisAbled(true)
            }
            else if(parseInt(props.id) !== 0){
                setdisAbled(true)
            }
            else{
                setdisAbled(false)
            }
        }
    })
    return (
        <div>
             <TextField
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="title"
           label={<IntlMessages id="user.Role"/>}
           value={Value}
           disabled={disAbled}
           InputLabelProps={{ shrink: true }}
           onChange={onchangeHandle}
           onBlur={onBlurHandle}
           /> 
        </div>
    );
}

export default KontaktRoll;